import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import Header from '../topbotm/Header';
import Footer from '../topbotm/Footer';
import Sidebar from '../dashboard/sidebar';
import { Button, Col, Row, Form, Card } from 'react-bootstrap';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import Swal from 'sweetalert2';
import { ToastContainer, toast, Zoom } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { Stack, Typography, Switch } from '@mui/material';
import { styled } from '@mui/material/styles';
import { motion, AnimatePresence } from 'framer-motion';

import api from '../../api';
import { AddClient } from '../client/addcllient';
import { CopyMsg } from '../others/copy_msg';
import { MSGS } from '../others/msg';
import { Dimcontext } from "../../context/pagecontext";
import { AuthContext } from '../../context/authContext';
import { Datacontext } from "../../context/dataContext";
import '../css/others/Doc_Reg.css';

// --- CUSTOM 3-STATE TOGGLE COMPONENT ---
const ThreeStateToggle = ({ value, onChange, disabled }) => {
  // Logic for the sliding thumb
  const getTranslate = () => {
    if (value === 'yes') return 'translateX(38px)'; // Right (Purple)
    if (value === 'no') return 'translateX(2px)';   // Left (Yellow)
    return 'translateX(20px)';                      // Center (Neutral)
  };

  // Background Color Logic
  const getBgColor = () => {
    if (value === 'yes') return '#ece917'; // Theme Yellow
    if (value === 'no') return '#8a2be2';  // Theme Purple
    return '#d1d1d1';                      // Neutral Grey
  };

  // Icon Color Logic (High Contrast)
  const getIconColor = (type) => {
    if (value === null) return '#555'; // Visible grey when neutral
    
    if (type === 'no') {
      // If 'No' is selected, background is Purple (#8a2be2), so icon should be Yellow
      return value === 'no' ? '#ece917' : 'rgba(0, 0, 0, 0.2)';
    }
    
    if (type === 'yes') {
      // If 'Yes' is selected, background is Yellow (#ece917), so icon should be Purple
      return value === 'yes' ? '#4a127e' : '#ece917';
    }
  };


  const handleClick = (e) => {
    if (disabled) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    // Decision logic based on new smaller width (66px)
    if (x < 22) onChange('no');
    else if (x > 44) onChange('yes');
    else onChange(null);
  };

  return (
    <div
      onClick={handleClick}
      style={{
        position: 'relative', 
        width: '66px', 
        height: '26px',
        backgroundColor: getBgColor(), 
        borderRadius: '13px',
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between',
        padding: '0 8px', 
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.6 : 1, 
        transition: 'all 0.3s ease',
        boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.2)',
        border: '1px solid rgba(0,0,0,0.1)'
      }}
    >
      {/* Icons flipped: X on left, Check on right */}
      <span style={{ color: getIconColor('no'), fontWeight: 'bold', zIndex: 1, fontSize: '12px', transition: 'color 0.3s' }}>✕</span>
      <span style={{ color: getIconColor('yes'), fontWeight: 'bold', zIndex: 1, fontSize: '12px', transition: 'color 0.3s' }}>✓</span>
      
      {/* Sliding Thumb */}
      <div style={{
        position: 'absolute', 
        top: '2px', 
        left: '0',
        width: '20px', 
        height: '20px', 
        backgroundColor: '#fff',
        borderRadius: '50%', 
        transition: 'transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1)',
        transform: getTranslate(), 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
      }}>
        <div style={{ 
          width: '4px', 
          height: '4px', 
          backgroundColor: getBgColor(), 
          borderRadius: '50%',
          transition: 'background-color 0.3s' 
        }} />
      </div>
    </div>
  );
};

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28, height: 16, padding: 0, display: 'flex',
  '&:active': { '& .MuiSwitch-thumb': { width: 15 }, '& .MuiSwitch-switchBase.Mui-checked': { transform: 'translateX(9px)' } },
  '& .MuiSwitch-switchBase': { padding: 2, '&.Mui-checked': { transform: 'translateX(12px)', color: '#fff', '& + .MuiSwitch-track': { opacity: 1, backgroundColor: '#e7ac2d' } } },
  '& .MuiSwitch-thumb': { boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)', width: 12, height: 12, borderRadius: 6 },
  '& .MuiSwitch-track': { borderRadius: 16 / 2, opacity: 1, backgroundColor: 'rgba(0,0,0,.25)', boxSizing: 'border-box' },
}));

const TitleCase = (str) => {
  return str ? str.toLowerCase().replace(/\s+/g, ' ').split(' ').map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : "";
};

const RegistrationNl = () => {
  const { user } = useContext(AuthContext);
  const { nl_Count, users, clients, fetchClients, fetchNl, fetchcountnl, sOffice, sZone } = useContext(Datacontext);
  const { setDim } = useContext(Dimcontext);

  // States
  const [date, set_Date] = useState("");
  const [app_No, set_App_No] = useState('');
  const [options, set_options] = useState([]);
  const [option_User, set_options_User] = useState([]);
  const [users1, set_users] = useState([]);
  const [ref, set_ref] = useState(null);
  const [off, set_off] = useState(null);
  const [zone, set_zone] = useState(null);
  const [owner, set_Owner] = useState(null);
  const [add, setAdd] = useState(false);
  const [msg, set_msg] = useState(false);
  const [activeMsgText, setActiveMsgText] = useState("");
  const [bt, setBt] = useState(false);
  const [estimatedCost, setEstimatedCost] = useState('');
  const [currentStep, setCurrentStep] = useState(1);
  const [status, setStatus] = useState({ click: 0, status: 'online' });

  // Document Details Logic
  const [docDetails, setDocDetails] = useState({
    nlno: { values: null, no: "", clicked: 0 },
    payment: { values: null, val: "", clicked: 0 },
    stamp_paper: { values: null, val: "", clicked: 0 },
    nl_received: { values: null, clicked: 0 },
    nl_delivered: { values: null, clicked: 0 }
  });

  const showToast = (msg) => toast.warn(msg, { position: "bottom-center", autoClose: 3000, theme: "dark", transition: Zoom });

  const get_customer = useCallback(() => {
    set_options(clients.map((v) => ({ value: v, label: `${v.name?.toUpperCase()} - ${v.nick_name || ""} - ${v.mobile}` })));
  }, [clients]);

  const get_User = useCallback(() => {
    set_options_User(users.map((u) => ({ value: u.name, label: u.name?.toUpperCase() })));
    set_users([{ value: user.name, label: user.name?.toUpperCase() || '' }]);
  }, [users, user]);

  const defaultn = useCallback(() => {
    const today = new Date();
    const d = String(today.getDate()).padStart(2, "0");
    const m = String(today.getMonth() + 1).padStart(2, "0");
    const y = today.getFullYear();
    set_App_No(`TD/NL/${y}/${String(nl_Count?.data?.number || 0).padStart(3, "0")}`);
    set_Date(`${d}-${m}-${y}`);
  }, [nl_Count]);

  useEffect(() => { get_User(); defaultn(); get_customer(); }, [get_User, defaultn, get_customer]);

  const handleCreate_cus = () => { setAdd(true); setDim(true); get_customer(); };

  const handleToggle = (event) => {
    setStatus({ click: status.click + 1, status: event.target.checked ? 'online' : 'offline' });
  };

  const handleDocToggleChange = (field, newValue) => {
    setDocDetails(prev => ({ ...prev, [field]: { ...prev[field], values: newValue } }));
  };

  const canToggle = (field) => {
    if (user?.role === "user" && docDetails[field].clicked >= 1) return false;
    return true;
  };

  const DATA = { zones: sZone, offices: sOffice };
  const [formData, setFormData] = useState({ zoneId: '', officeId: '' });
  const formOffices = useMemo(() => (DATA.offices || []).filter(o => o.zoneId === formData.zoneId), [formData.zoneId, DATA.offices]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'zoneId') setFormData({ zoneId: value, officeId: '' });
    else if (name === 'officeId') setFormData({ ...formData, officeId: value });
  };

  // Validation Logic
  const isStep1Complete = useMemo(() => {
    return formData.zoneId && formData.officeId && users1.length > 0 && !!ref?.value && !!owner?.value;
  }, [formData, users1, ref, owner]);

  const isStep2Complete = useMemo(() => {
    const hasCost = !!estimatedCost;
    let hasPrimaryDetails = false;
    if (status.status === 'online') {
      hasPrimaryDetails = docDetails.nlno.values === 'no' || (docDetails.nlno.values === 'yes' && !!docDetails.nlno.no);
    } else {
      const nlno = !!docDetails.nlno.values
      const hasPay = docDetails.payment.values === 'no' || (docDetails.payment.values === 'yes' && !!docDetails.payment.val);
      const hasStamp = docDetails.stamp_paper.values === 'no' || (docDetails.stamp_paper.values === 'yes' && !!docDetails.stamp_paper.val);
      hasPrimaryDetails = hasPay && hasStamp && nlno;
    }
    return hasPrimaryDetails && hasCost && !!docDetails.nl_received.values && !!docDetails.nl_delivered.values;
  }, [status.status, docDetails, estimatedCost]);

  const validateMandatory = () => {
  // 2. Check CCA Number if "Yes" is selected for Online
  if (status.status === 'online' && docDetails.nlno.values === 'yes' && !docDetails.nlno.no) {
    showToast("Please enter the mandatory CCA Number.");
    return false;
  }

  // 3. Check Payment & Stamp Paper if Offline
  if (status.status === 'offline') {
    if (docDetails.payment.values === 'yes' && !docDetails.payment.val) {
      showToast("Please enter the Payment value.");
      return false;
    }
    if (docDetails.stamp_paper.value === 'yes' && !docDetails.stamp_paper.val) {
      showToast("Please enter the Stamp Paper details.");
      return false;
    }
  }

  return true;
};

const handleSubmit = async (e) => {
  e.preventDefault();
  if(!validateMandatory()) return;

  const isOnline = status.status === 'online';

  // Dynamic row for Online vs Offline document info
  const docInfoRow = isOnline
    ? `
      <p><strong>Certificate Copy Applicantion Status:</strong> ${docDetails.nlno.values?.toUpperCase() || 'PENDING'}</p>
      ${docDetails.nlno.valuse === 'yes' ? `<p><strong>Certificate Copy Applicantion No:</strong> ${docDetails.nlno.no}</p>` : ''}
    `
    : `
      <p><strong>Certificate Copy Applicantion Status:</strong> ${docDetails.nlno.values?.toUpperCase() || 'PENDING'}</p>
      <p><strong>Payment Status:</strong> ${docDetails.payment.values?.toUpperCase() || 'PENDING'}</p>
      ${docDetails.payment.values === 'yes' ? `<p><strong>Payment Value:</strong> ₹${docDetails.payment.val}</p>` : ''}
      <p><strong>Stamp Paper Status:</strong> ${docDetails.stamp_paper.values?.toUpperCase() || 'PENDING'}</p>
      ${docDetails.stamp_paper.values === 'yes' ? `<p><strong>Stamp Paper Details:</strong> ${docDetails.stamp_paper.val}</p>` : ''}
    `;

  // Enhanced stylings for the SweetAlert confirmation
  const summaryHtml = `
    <div style="text-align: left; font-size: 14px; color: #4a127e; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; line-height: 1.6;">
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; padding-bottom: 8px; border-bottom: 2px solid #f0f0f0;">
          <span style="font-size: 16px;"><strong># ${app_No}</strong></span>
          <span style="background-color: ${isOnline ? '#8a2be2' : '#e7ac2d'}; color: white; padding: 4px 10px; border-radius: 20px; font-size: 11px; font-weight: bold; text-transform: uppercase;">
              ${status.status}
          </span>
      </div>
      
      <div style="background-color: #f9f7ff; padding: 10px; border-radius: 8px; margin-bottom: 10px;">
        <p style="margin: 0;"><strong>Zone:</strong> ${zone?.toUpperCase() || 'N/A'}</p>
        <p style="margin: 0;"><strong>Office:</strong> ${typeof off === 'string' ? off.toUpperCase() : off?.label || 'N/A'}</p>
        <p style="margin: 0;"><strong>Managed By:</strong> ${users1.map(u => u.label).join(', ')}</p>
      </div>

      <p><strong>Referred By:</strong> ${ref?.value?.name?.toUpperCase() || 'DIRECT'}</p>
      <p><strong>Executant:</strong> ${owner?.value?.name?.toUpperCase() || 'N/A'}</p>
      
      <div style="margin: 10px 0; padding: 10px; border: 1px dashed #8a2be2; border-radius: 8px;">
        ${docInfoRow}
        <p><strong>Certificate Copy Prepared:</strong> ${docDetails.nl_received.values?.toUpperCase() || 'PENDING'}</p>
        <p><strong>Certificate Copy  Delivered:</strong> ${docDetails.nl_delivered.values?.toUpperCase() || 'PENDING'}</p>
      </div>

      <p style="font-size: 15px; text-align: right; margin-top: 10px;">
        <strong>Estimated Cost:</strong> <span style="color: #28a745; font-weight: bold;">${estimatedCost ? `₹${estimatedCost}` : '₹0'}</span>
      </p>
    </div>
  `;

  const result = await Swal.fire({
    title: 'Confirm Submission',
    html: summaryHtml,
    icon: "question",
    showCancelButton: true,
    confirmButtonColor: "#8a2be2",
  });

  if (!result.isConfirmed) return;
  setBt(true);

  // LOGIC: Increase click count ONLY for fields that were actually filled/changed
  const processClicks = (field) => {
    const currentField = docDetails[field];
    return {
      ...currentField,
      // If a value was selected, click becomes 1, else stays 0
      clicked: currentField.values !== null ? (currentField.clicked + 1) : 0
    };
  };

  const payload = {
    application_no: app_No,
    date: date,
    zone: zone?.toLowerCase(),
    register_office: typeof off === 'string' ? off.toLowerCase() : off?.value?.toLowerCase() || '',
    managed_By: users1.map(u => u.value),
    refered_by: ref?.value || null,
    owner: owner?.value || null,
    status: status || null,
    
    // Apply the click increment here
    nlno: processClicks('nlno'),
    payment: processClicks('payment'),
    stamp_paper: processClicks('stamp_paper'),
    nl_received: processClicks('nl_received'),
    nl_delivered: processClicks('nl_delivered'),
    
    estimated_cost: estimatedCost,
    docstatus: 'processing',
  };

  try {
    const res = await api.post('/add_nl', payload);
    
    // Refresh Data
    fetchNl();
    await api.put('nl_count', { year: new Date().getFullYear().toString() });
    fetchcountnl();

    Swal.fire({ text: res.data.message, icon: "success", timer: 2000, showConfirmButton: false });
    
    // Reset Form
    setCurrentStep(1);
    set_Owner(null);
    set_ref(null);
    setDocDetails({
      nlno: { values: null, no: "", clicked: 0 },
      payment: { values: null, val: "", clicked: 0 },
      stamp_paper: { values: null, val: "", clicked: 0 },
      nl_received: { values: null, clicked: 0 },
      nl_delivered: { values: null, clicked: 0 }
    });
    setEstimatedCost('');

  } catch (error) {
    console.error(error);
  } finally {
    setBt(false);
  }
};

  const handleMsg = (type, data) => {
    setActiveMsgText(MSGS[type](data));
    set_msg(true);
    setDim(true);
  };

  const selectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: '38px',
      borderRadius: '0.375rem',
      borderColor: state.isFocused ? 'var(--brand-purple)' : '#dee2e6',
      boxShadow: state.isFocused ? '0 0 0 1px var(--brand-purple)' : 'none',
      '&:hover': {
        borderColor: 'var(--brand-purple)'
      }
    }),
    // This ensures the menu is physically moved to the <body> 
    // so it ignores "overflow: hidden" on your Cards
    menuPortal: (base) => ({ 
      ...base, 
      zIndex: 9999 
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected 
        ? 'var(--brand-purple)' 
        : state.isFocused 
        ? 'rgba(74, 18, 126, 0.1)' 
        : 'white',
      color: state.isSelected ? 'white' : 'var(--bs-body-color)',
    })
  };

  const validateCurrentStep = (stepToValidate = currentStep) => {
    switch (stepToValidate) {
        case 1:
            // --- Mandatory Application Details & Applicant Info ---
            if (!formData.zoneId) { showToast("Please select a Zone."); return false; }
            if (!formData.officeId) { showToast("Please select an Office."); return false; }
            if (!users1 || users1.length === 0) { showToast("Please assign at least one User."); return false; }
            break;

        case 2:
            // 2. Primary Conditional Fields (Online vs Offline)
            if (status.status === 'online') {
                if (docDetails.nlno.values === 'yes' && !docDetails.nlno.no) {
                    showToast("Please provide the NL Number.");
                    return false;
                }
            } else {
                if (docDetails.payment.values === 'yes' && !docDetails.payment.val) {
                    showToast("Please enter the Payment Value details.");
                    return false;
                }
                if (docDetails.stamp_paper.values === 'yes' && !docDetails.stamp_paper.val) {
                    showToast("Please enter the Stamp Paper Value.");
                    return false;
                }
              }
            break;

        // ... Keep your other cases (case 3, case 4, etc.) down here ...

        default:
            break;
    } 

    return true; // All checks passed, allows navigation
};

  return (
    <div className="dashboard-page bg-light min-vh-100">
      <Header />
      <ToastContainer autoClose={3000} />
      <div className="dashboard-wrapper">
        <div className="d-none" style={{ backgroundColor: "#4a127e" }}><Sidebar user={user} /></div>
        <main className="main-area py-4">
          <div className="container-xxl">
            
            {/* TOP HEADER */}
            <Card className="shadow-sm mb-4 border-0 rounded-3 overflow-hidden" style={{ borderTop: '5px solid #e7ac2d' }}>
              <Card.Header className="border-0 pt-4 px-4" style={{ backgroundColor: '#fffdf5' }}>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h5 className="fw-bold mb-0" style={{ color: "#4a127e", letterSpacing: '-0.5px' }}>
                      Application Details
                    </h5>
                    <small className="text-muted">General administrative information</small>
                  </div>
                  <i className="bi bi-info-circle text-muted" title="Automatic system generated fields"></i>
                </div>
              </Card.Header>

              <Card.Body className="px-4 pb-4" style={{ backgroundColor: '#fffdf5' }}>
                <Row className="g-4">
                  
                  {/* APP NO - READ ONLY */}
                  <Form.Group as={Col} xs={12} sm={6} md={4}>
                    <Form.Label className="small fw-bold text-muted text-uppercase mb-1" style={{ fontSize: '0.7rem' }}>
                      Application No.
                    </Form.Label>
                    <Form.Control 
                      type="text" 
                      value={app_No} 
                      readOnly 
                      className="bg-white border-0 shadow-none fw-bold text-dark" 
                      style={{ height: '42px', fontSize: '15px' }}
                    />
                  </Form.Group>

                  {/* DATE - READ ONLY */}
                  <Form.Group as={Col} xs={12} sm={6} md={4}>
                    <Form.Label className="small fw-bold text-muted text-uppercase mb-1" style={{ fontSize: '0.7rem' }}>
                      Registration Date
                    </Form.Label>
                    <Form.Control 
                      type="text" 
                      value={date} 
                      readOnly 
                      className="bg-white border-0 shadow-none fw-bold text-dark" 
                      style={{ height: '42px', fontSize: '15px' }}
                    />
                  </Form.Group>

                  {/* ZONE SELECT */}
                  <Form.Group as={Col} xs={12} sm={6} md={4}>
                    <Form.Label className="small fw-bold text-muted text-uppercase mb-1" style={{ fontSize: '0.7rem' }}>
                      Zone <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select 
                      className="shadow-none border-secondary-subtle fw-semibold"
                      style={{ height: '42px', fontSize: '14px' }}
                      name="zoneId" 
                      value={formData.zoneId || ""} 
                      onChange={(e) => { 
                        handleChange(e); 
                        const selectedZone = DATA.zones.find(v => v.id === e.target.value);
                        set_zone(selectedZone ? selectedZone.zoneName : ""); 
                      }}
                    >
                      <option value="">-- Select Zone --</option>
                      {[...DATA.zones].sort((a, b) => a.zoneName.localeCompare(b.zoneName)).map((z) => (<option key={z.id} value={z.id}>{z.zoneName.toUpperCase()}</option>))}
                    </Form.Select>
                  </Form.Group>

                  {/* OFFICE SELECT */}
                  <Form.Group as={Col} xs={12} sm={6} md={4}>
                    <Form.Label className="small fw-bold text-muted text-uppercase mb-1" style={{ fontSize: '0.7rem' }}>
                      Office / SRO <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select 
                      className="shadow-none border-secondary-subtle fw-semibold"
                      style={{ height: '42px', fontSize: '14px' }}
                      name="officeId" 
                      value={formData.officeId || ""} 
                      disabled={!formData.zoneId}
                      onChange={(e) => { 
                        handleChange(e); 
                        const selectedOff = formOffices.find(v => v.id === e.target.value);
                        set_off(selectedOff ? selectedOff.officeName : ""); 
                      }} 
                    >
                      <option value="">-- Select Office --</option>
                      {[...formOffices].sort((a, b) => a.officeName.localeCompare(b.officeName)).map((o) => (<option key={o.id} value={o.id}>{o.officeName.toUpperCase()}</option>))}
                    </Form.Select>
                  </Form.Group>

                  {/* MANAGED BY - MULTI SELECT */}
                  <Form.Group as={Col} xs={12} md={8}>
                    <Form.Label className="small fw-bold text-muted text-uppercase mb-1" style={{ fontSize: '0.7rem' }}>
                      Managed By <span className="text-danger">*</span>
                    </Form.Label>
                    <Select 
                      isMulti 
                      isDisabled={user.role === "user"} 
                      options={option_User || []} 
                      value={users1 || []} 
                      placeholder="Assign staff members..." 
                      onChange={(val) => set_users(val ? [...val] : [])}
                      styles={selectStyles}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                    />
                  </Form.Group>
                </Row>
              </Card.Body>
            </Card>

            {/* STEPPER VISUAL */}
            <div className="d-flex justify-content-center align-items-center mb-5 px-3 py-4 overflow-auto custom-scrollbar">
            {[
              { id: 1, label: "Applicant Info", complete: isStep1Complete },
              { id: 2, label: "Document Process", complete: isStep2Complete },
              // Easily add more steps here:
              // { id: 3, label: "Verification", complete: isStep3Complete },
            ].map((step, index, array) => (
              <React.Fragment key={step.id}>
                {/* --- STEP NODE --- */}
                <div 
                  className="d-flex flex-column align-items-center position-relative" 
                  style={{ cursor: 'pointer', minWidth: '130px' }}
                  onClick={()=>{
                  if(!validateCurrentStep(currentStep)) return
                  setCurrentStep(currentStep === 1 ? 2 : 1 )
                }}>
                  <div style={{
                    width: '42px', height: '42px', borderRadius: '50%',
                    display: 'flex', justifyContent: 'center', alignItems: 'center', 
                    fontWeight: 'bold', fontSize: '16px', transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    
                    // Active Step "Halo"
                    boxShadow: currentStep === step.id ? '0 0 0 5px rgba(138, 43, 226, 0.2)' : 'none',
                    
                    // Background & Border Logic
                    backgroundColor: step.complete ? '#8a2be2' : (currentStep === step.id ? '#f5f258' : '#f8f9fa'),
                    color: step.complete ? '#ece917' : (currentStep === step.id ? '#4a127e' : '#adb5bd'),
                    border: (step.complete || currentStep === step.id) ? '2px solid #8a2be2' : '2px solid #dee2e6',
                    
                    zIndex: 2,
                    // Pop effect on active
                    transform: currentStep === step.id ? 'scale(1.1)' : 'scale(1)'
                  }}>
                    {step.complete ? '✓' : step.id}
                  </div>
                  
                  <span className="mt-2 fw-bold text-center text-uppercase" style={{ 
                    fontSize: '10px', 
                    letterSpacing: '0.5px',
                    color: step.complete || currentStep === step.id ? '#4a127e' : '#adb5bd',
                    transition: 'color 0.3s'
                  }}>
                    {step.label}
                  </span>
                </div>

                {/* --- DYNAMIC LINE CONNECTOR --- */}
                {index < array.length - 1 && (
                  <div style={{ 
                    flex: '1', 
                    maxWidth: '120px', 
                    minWidth: '40px',
                    height: '4px', 
                    borderRadius: '2px',
                    backgroundColor: '#e9ecef', 
                    margin: '0 -15px', // Tucks line behind circles
                    marginBottom: '22px', // Perfect center alignment with 42px circles
                    position: 'relative',
                    overflow: 'hidden',
                    zIndex: 1
                  }}>
                    <motion.div 
                      initial={false}
                      animate={{ width: step.complete ? '100%' : '0%' }} 
                      transition={{ duration: 0.5, ease: "easeInOut" }}
                      style={{ height: '100%', backgroundColor: '#8a2be2' }} 
                    />
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>

            <Form onSubmit={handleSubmit}>
              {currentStep === 1 && (
                <motion.div 
                  initial={{ opacity: 0, x: -20 }} 
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <Card className="shadow-sm mb-4 border-0 rounded-3 overflow-hidden">
                    <Card.Header className="bg-white border-0 pt-4 px-4">
                      <h5 className="fw-bold mb-0" style={{ color: "#4a127e" }}>
                        Reference & Executant Details
                      </h5>
                      <p className="text-muted small mb-0">Select existing profiles or create new ones for this application.</p>
                    </Card.Header>
                    
                    <Card.Body className="px-4 pb-4">
                      {/* --- REFERRED BY SECTION --- */}
                      <div className="mb-5 p-3 rounded-3" style={{ backgroundColor: '#f8f9fa', borderLeft: '4px solid #8a2be2' }}>
                        <h6 className="small fw-bold text-uppercase mb-3" style={{ color: '#8a2be2', letterSpacing: '0.5px' }}>
                          <i className="bi bi-person-badge me-2"></i>Referred By
                        </h6>
                        <Row className="g-3">
                          <Form.Group as={Col} xs={12} sm={6} md={3}>
                            <Form.Label className="small fw-bold text-muted">NAME</Form.Label>
                            <CreatableSelect 
                              isClearable 
                              value={ref ? { value: ref.value, label: ref.value?.name?.toUpperCase() } : null} 
                              options={options || []} 
                              onCreateOption={handleCreate_cus} 
                              placeholder="Search..." 
                              onChange={set_ref} 
                              styles={selectStyles}
                              menuPortalTarget={document.body} 
                            />
                          </Form.Group>
                          <Form.Group as={Col} xs={12} sm={6} md={3}>
                            <Form.Label className="small fw-bold text-muted">ADDRESS</Form.Label>
                            <Form.Control readOnly value={TitleCase(ref?.value?.address)} className="bg-white border-0 shadow-none fw-semibold" style={{ fontSize: '14px' }} />
                          </Form.Group>
                          <Form.Group as={Col} xs={12} sm={6} md={3}>
                            <Form.Label className="small fw-bold text-muted">DISTRICT</Form.Label>
                            <Form.Control readOnly value={TitleCase(ref?.value?.city)} className="bg-white border-0 shadow-none fw-semibold" style={{ fontSize: '14px' }} />
                          </Form.Group>
                          <Form.Group as={Col} xs={12} sm={6} md={3}>
                            <Form.Label className="small fw-bold text-muted">MOBILE</Form.Label>
                            <Form.Control readOnly value={ref?.value?.mobile || ''} className="bg-white border-0 shadow-none fw-semibold" style={{ fontSize: '14px' }} />
                          </Form.Group>
                        </Row>
                      </div>

                      {/* --- EXECUTANT SECTION --- */}
                      <div className="p-3 rounded-3" style={{ backgroundColor: '#fffdf5', borderLeft: '4px solid #e7ac2d' }}>
                        <h6 className="small fw-bold text-uppercase mb-3" style={{ color: '#4a127e', letterSpacing: '0.5px' }}>
                          <i className="bi bi-house-door me-2"></i>Executant (Owner)
                        </h6>
                        <Row className="g-3">
                          <Form.Group as={Col} xs={12} sm={6} md={3}>
                            <Form.Label className="small fw-bold text-muted">NAME</Form.Label>
                            <CreatableSelect 
                              isClearable 
                              value={owner} 
                              options={options || []} 
                              onCreateOption={handleCreate_cus} 
                              placeholder="Search..." 
                              onChange={set_Owner} 
                              styles={selectStyles}
                              menuPortalTarget={document.body}
                            />
                          </Form.Group>
                          <Form.Group as={Col} xs={12} sm={6} md={3}>
                            <Form.Label className="small fw-bold text-muted">ADDRESS</Form.Label>
                            <Form.Control readOnly value={TitleCase(owner?.value?.address)} className="bg-white border-0 shadow-none fw-semibold" style={{ fontSize: '14px' }} />
                          </Form.Group>
                          <Form.Group as={Col} xs={12} sm={6} md={3}>
                            <Form.Label className="small fw-bold text-muted">DISTRICT</Form.Label>
                            <Form.Control readOnly value={TitleCase(owner?.value?.city)} className="bg-white border-0 shadow-none fw-semibold" style={{ fontSize: '14px' }} />
                          </Form.Group>
                          <Form.Group as={Col} xs={12} sm={6} md={3}>
                            <Form.Label className="small fw-bold text-muted">MOBILE</Form.Label>
                            <Form.Control readOnly value={owner?.value?.mobile || ''} className="bg-white border-0 shadow-none fw-semibold" style={{ fontSize: '14px' }} />
                          </Form.Group>
                        </Row>
                      </div>
                    </Card.Body>
                  </Card>
                </motion.div>
              )}

              {currentStep === 2 && (
                <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.3 }}>
                  <Card className="shadow-sm mb-4 border-0 rounded-3 overflow-hidden">
                    {/* HEADER WITH REFINED TOGGLE */}
                    <Card.Header className="bg-white border-0 pt-4 px-4 d-flex justify-content-between align-items-center">
                      <div>
                        <h5 className="fw-bold mb-0" style={{ color: "#4a127e" }}>Document Process</h5>
                        <p className="text-muted small mb-0">Manage Certificate Copy (CCA) workflows</p>
                      </div>
                      <div className="p-2 rounded-pill border bg-light d-flex align-items-center px-3 shadow-sm">
                        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                          <Typography sx={{ fontSize: '11px', color: status.status === 'offline' ? '#e7ac2d' : '#adb5bd', fontWeight: 800, textTransform: 'uppercase' }}>Offline</Typography>
                          <AntSwitch checked={status.status === 'online'} onChange={handleToggle} disabled={user.role === "user" && status.click >= 2} />
                          <Typography sx={{ fontSize: '11px', color: status.status === 'online' ? '#8a2be2' : '#adb5bd', fontWeight: 800, textTransform: 'uppercase' }}>Online</Typography>
                        </Stack>
                      </div>
                    </Card.Header>

                    <Card.Body className="px-4 pb-4">
                      <Row className="g-4">
                        {/* CCA NO SECTION */}
                        <Col xs={12} md={4}>
                          <div className={`p-3 rounded-3 border h-100 ${docDetails.nlno.values === 'yes' ? 'bg-light border-primary-subtle' : 'bg-white'}`}>
                            <Form.Group>
                              <Form.Label className="small fw-bold text-muted text-uppercase mb-2 d-block">
                                Certificate Copy Application {status.status === "online" && "No."} {status.status === "online" && docDetails.nlno.values === 'yes' && <span className="text-danger">*</span>}
                              </Form.Label>
                              <div className="mb-2">
                                <ThreeStateToggle 
                                  value={docDetails.nlno.values} 
                                  onChange={(val) => handleDocToggleChange('nlno', val)} 
                                  disabled={!canToggle('nlno')} 
                                />
                              </div>
                              
                              {docDetails.nlno.value === 'yes' && (
                                <Button 
                                  size="sm" 
                                  className="w-100 py-1 fw-bold rounded-pill mb-2 shadow-sm border-0" 
                                  style={{backgroundColor: '#8a2be2', fontSize: '11px'}}
                                  onClick={() => handleMsg((status.status === "online"?'WELCOME1':'WELCOME2'), { app_no: app_No, document_number: `CCA/Online/${docDetails.nlno.no}/${new Date().getFullYear()}` })}
                                >
                                  <i className="bi bi-chat-left-text me-2"></i>Copy Msg
                                </Button>
                              )}

                              {status.status === "online" && docDetails.nlno.values === 'yes' && (
                                <Form.Control 
                                  className="shadow-none fw-bold" 
                                  value={docDetails.nlno.no || ''} 
                                  onChange={(e) => setDocDetails(p => ({ ...p, nlno: { ...p.nlno, no: e.target.value } }))} 
                                  type="number" 
                                  placeholder="Enter CCA No." 
                                  required
                                  isInvalid={!docDetails.nlno.no}
                                />
                              )}
                            </Form.Group>
                          </div>
                        </Col>

                        {/* OFFLINE FIELDS: PAYMENT & STAMP PAPER */}
                        {status.status === "offline" && (
                          <>
                            <Col xs={12} md={4}>
                              <div className={`p-3 rounded-3 border h-100 ${docDetails.payment.values === 'yes' ? 'bg-light border-warning-subtle' : 'bg-white'}`}>
                                <Form.Group>
                                  <Form.Label className="small fw-bold text-muted text-uppercase mb-2 d-block">
                                    Payment Details {docDetails.payment.values === 'yes' && <span className="text-danger">*</span>}
                                  </Form.Label>
                                  <div className="mb-2">
                                    <ThreeStateToggle 
                                      value={docDetails.payment.values} 
                                      onChange={(val) => handleDocToggleChange('payment', val)} 
                                      disabled={!canToggle('payment')} 
                                    />
                                  </div>
                                  {docDetails.payment.values === 'yes' && (
                                    <div className="input-group input-group-sm">
                                      <span className="input-group-text bg-white text-muted">₹</span>
                                      <Form.Control 
                                        className="shadow-none fw-bold" 
                                        value={docDetails.payment.val || ''} 
                                        onChange={(e) => setDocDetails(p => ({ ...p, payment: { ...p.payment, val: e.target.value } }))} 
                                        type="number" 
                                        placeholder="Value" 
                                        required
                                        isInvalid={!docDetails.payment.val}
                                      />
                                    </div>
                                  )}
                                </Form.Group>
                              </div>
                            </Col>

                            <Col xs={12} md={4}>
                              <div className={`p-3 rounded-3 border h-100 ${docDetails.stamp_paper.values === 'yes' ? 'bg-light border-warning-subtle' : 'bg-white'}`}>
                                <Form.Group>
                                  <Form.Label className="small fw-bold text-muted text-uppercase mb-2 d-block">
                                    Stamp Paper {docDetails.stamp_paper.values === 'yes' && <span className="text-danger">*</span>}
                                  </Form.Label>
                                  <div className="mb-2">
                                    <ThreeStateToggle 
                                      value={docDetails.stamp_paper.values} 
                                      onChange={(val) => handleDocToggleChange('stamp_paper', val)} 
                                      disabled={!canToggle('stamp_paper')} 
                                    />
                                  </div>
                                  {docDetails.stamp_paper.values=== 'yes' && (
                                    <Form.Control 
                                      size="sm"
                                      className="shadow-none fw-bold" 
                                      value={docDetails.stamp_paper.val || ''} 
                                      onChange={(e) => setDocDetails(p => ({ ...p, stamp_paper: { ...p.stamp_paper, val: e.target.value } }))} 
                                      type="text" 
                                      placeholder="Details..." 
                                      required
                                      isInvalid={!docDetails.stamp_paper.val}
                                    />
                                  )}
                                </Form.Group>
                              </div>
                            </Col>
                          </>
                        )}

                        {/* CCA RECEIVED */}
                        <Col xs={12} md={4}>
                          <div className={`p-3 rounded-3 border h-100 ${docDetails.nl_received.values === 'yes' ? 'bg-light border-success-subtle' : 'bg-white'}`}>
                            <Form.Group>
                              <Form.Label className="small fw-bold text-muted text-uppercase mb-2 d-block">Certificate Copy Prepared</Form.Label>
                              <div className="mb-2">
                                <ThreeStateToggle 
                                  value={docDetails.nl_received.values} 
                                  onChange={(val) => handleDocToggleChange('nl_received', val)} 
                                  disabled={!canToggle('nl_received')} 
                                />
                              </div>
                              {docDetails.nl_received.values === 'yes' && (
                                <Button 
                                  size="sm" 
                                  className="w-100 py-1 fw-bold rounded-pill shadow-sm border-0" 
                                  style={{backgroundColor: '#198754', fontSize: '11px'}}
                                  onClick={() => handleMsg((status.status === "online"?'COLLECTED':'COLLECTED1'), { 
                                    app_no: app_No, 
                                    document_number: `CCA/Online/${docDetails.nlno.no || ''}/${new Date().getFullYear()}`, 
                                    office: typeof off === 'string' ? off.toUpperCase() : off?.value?.toUpperCase() 
                                  })}
                                >
                                  <i className="bi bi-check-all me-1"></i> Copy Msg
                                </Button>
                              )}
                            </Form.Group>
                          </div>
                        </Col>

                        {/* CCA DELIVERED */}
                        <Col xs={12} md={4}>
                          <div className={`p-3 rounded-3 border h-100 ${docDetails.nl_delivered.values === 'yes' ? 'bg-light border-info-subtle' : 'bg-white'}`}>
                            <Form.Group>
                              <Form.Label className="small fw-bold text-muted text-uppercase mb-2 d-block">Certificate Copy Delivered</Form.Label>
                              <div className="mb-2">
                                <ThreeStateToggle 
                                  value={docDetails.nl_delivered.values} 
                                  onChange={(val) => handleDocToggleChange('nl_delivered', val)} 
                                  disabled={!canToggle('nl_delivered')} 
                                />
                              </div>
                            </Form.Group>
                          </div>
                        </Col>

                        {/* ESTIMATED COST & THANK YOU */}
                        <Col xs={12} md={4}>
                          <div className="p-3 rounded-3 border bg-white h-100 shadow-sm border-warning-subtle">
                            <Form.Group className="mb-3">
                              <Form.Label className="small fw-bold text-muted text-uppercase mb-1">Estimated Cost</Form.Label>
                              <div className="input-group">
                                <span className="input-group-text bg-light border-0">₹</span>
                                <Form.Control 
                                  className="shadow-none border-0 bg-light fw-bold"
                                  value={estimatedCost} 
                                  onChange={(e) => setEstimatedCost(e.target.value)} 
                                  type="number" 
                                  placeholder="0.00" 
                                />
                              </div>
                            </Form.Group>
                            <Button 
                              variant="outline-warning" 
                              className="w-100 fw-bold py-2 rounded-pill shadow-sm" 
                              style={{color: '#4a127e', borderColor: '#dbe72d', borderWidth: '2px'}} 
                              onClick={() => handleMsg((status.status === "online"?'THANK':'THANK1'), { 
                                app_no: app_No, 
                                document_number: `CCA/Online/${docDetails.nlno.no || ''}/${new Date().getFullYear()}` 
                              })}
                            >
                              <i className="bi bi-stars me-2"></i>Send Thank You
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </motion.div>
              )}

              <div className="d-flex justify-content-between mb-5">
                <Button variant="secondary" onClick={()=>{
                  if(!validateCurrentStep(currentStep)) return
                  setCurrentStep(p=>p-1)
                }} disabled={currentStep === 1}>Back</Button>
                <div className="d-flex gap-2">
                  {currentStep === 1 && <Button style={{backgroundColor: '#8a2be2'}} className="text-white" onClick={()=>{
                    if(!validateCurrentStep(currentStep)) return
                  setCurrentStep(p=>p+1)
                  }}>Next Step</Button>}
                  <Button style={{backgroundColor: '#e7ac2d'}} className="text-white fw-bold" disabled={bt} type="submit">{bt ? 'Submitting...' : 'Submit'}</Button>
                </div>
              </div>
            </Form>
          </div>
        </main>
      </div>
      <Footer />

      <AnimatePresence>
        {add && <div className="modal-overlay-wrapper"><AddClient setAdd={setAdd} showToast={showToast} get_customer={fetchClients} /></div>}
        {msg && <div style={{ position: 'fixed', bottom: '40px', left: '0', right: '0', zIndex: 3000, display: 'flex', justifyContent: 'center' }}><CopyMsg set_msg={set_msg} content={activeMsgText} /></div>}
      </AnimatePresence>
    </div>
  );
};

export default RegistrationNl;